<flow-statistics-filter
  #filtersComponent
  flowStickyHeader
  [initData]="filterInputs"
  [activeReport]="activeReport"
  (filterChange)="onFilterChanged($event)"
  (onCreateReport)="onCreateReport()"
  (onDownloadReport)="onDownloadReport()"
  (fetchNextBookings)="fetchNextBookings()"
  (searchBookings)="searchBookings($event)"
  [downloadReportDisableBtn]="hideDownloadButton"
  [permissions]="permissions"></flow-statistics-filter>

<flow-reports-data
  *ngIf="reports  && activeReport !== ActiveReportEnum.Reach"
  [reports]="reports"
  [activeReport]="activeReport"
  [includeSmsDetailsPOI]="includeSmsDetailsPOI"
  [includeAdminDetailsPOI]="includeAdminDetailsPOI"
  [includeVehicleDataReach]="includeVehicleDataReach"
  [includeAverageTimeInChannel]="includeAvgTimeInChannel"
  [showDetailedReport]="showDetailedReport"
  [isAdmin]="isAdmin"
  (reportShown)="reportShown($event)"
  (getNewReport)="getNewReport($event)"></flow-reports-data>

<flow-tabs
  (selectedTabChange)="selectedTabChange($event)"
  [selectedIndex]="selectedIndex"
  [tabClass]="'my-6'"
  *ngIf="(peopleReport || vehicleReport  ) && activeReport === ActiveReportEnum.Reach">
  <flow-tabs-item title="{{'reach.people.title' | translate}}">

    <flow-kpi-box-single
      *ngIf="peopleReportCount"
      [title]="'reports.totalPeople' | translate"
      [value]="peopleReportCount"></flow-kpi-box-single>

    <flow-reports-data
      *ngIf="peopleReport"
      [reports]="peopleReport"
      [reachReportType]="ReachReportTypeEnum.ReachPeople"
      [activeReport]="activeReport"
      [includeSmsDetailsPOI]="includeSmsDetailsPOI"
      [includeAdminDetailsPOI]="includeAdminDetailsPOI"
      [includeVehicleDataReach]="includeVehicleDataReach"
      [includeAverageTimeInChannel]="includeAvgTimeInChannel"
  [showDetailedReport]="showDetailedReport"
      [isAdmin]="isAdmin"
      (reportShown)="reportShown($event)"
      (getNewReport)="getNewReport($event)"></flow-reports-data>
  </flow-tabs-item>
  <flow-tabs-item title="{{'reach.vehicles.title' | translate}}">

    <flow-kpi-box-single
      *ngIf="vehicleReportCount"
      [title]="'reports.totalVehicles' | translate"
      [value]="vehicleReportCount"></flow-kpi-box-single>

    <flow-reports-data
      *ngIf="vehicleReport"
      [reports]="vehicleReport"
      [reachReportType]="ReachReportTypeEnum.ReachVehicles"
      [activeReport]="activeReport"
      [includeSmsDetailsPOI]="includeSmsDetailsPOI"
      [includeAdminDetailsPOI]="includeAdminDetailsPOI"
      [includeVehicleDataReach]="includeVehicleDataReach"
      [includeAverageTimeInChannel]="includeAvgTimeInChannel"
  [showDetailedReport]="showDetailedReport"
      [isAdmin]="isAdmin"
      (reportShown)="reportShown($event)"
      (getNewReport)="getNewReport($event)"></flow-reports-data>
  </flow-tabs-item>
</flow-tabs>

<ng-container *ngIf="showNoData">
  <flow-no-data [label]="'reports.noData'"></flow-no-data>
</ng-container>
